import { CardBrand } from './card-brand';
export const getCardCvcLengthRangeByBrand = (cardBrand) => {
    switch (cardBrand) {
        case CardBrand.Visa:
        case CardBrand.Master:
        case CardBrand.Discover:
        case CardBrand.Diners:
        case CardBrand.Maestro:
        case CardBrand.UnionPay:
        case CardBrand.Jcb:
            return {
                min: 3,
                max: 3,
            };
        case CardBrand.American:
            return {
                min: 3,
                max: 4,
            };
        default:
            return {
                min: 3,
                max: 4,
            };
    }
};
//# sourceMappingURL=get-card-cvc-length-range-by-brand.js.map